module.exports = __webpack_public_path__ + "static/img/TRINITY_EP.e22324d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TRINITY_EP.jpg
// module id = y1Pz
// module chunks = 0